import { action } from '@ember/object';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import setElement from 'bcl/modifiers/set-element';

interface ModalSignature {
  // The arguments accepted by the component
  Args: {
    close?: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ModalComponent extends Component<ModalSignature> {
  <template>
    {{! template-lint-disable no-invalid-interactive }}
    <div
      class="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      {{on "click" this.close}}
    >

      <div
        class="fixed inset-0 bg-gray-500/75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >

          <div
            class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all my-8 w-full max-w-xl p-6"
            {{setElement this.registerModal}}
          >
            {{yield}}
          </div>
        </div>
      </div>
    </div>
  </template>
  get role() {
    if (this.args.close) {
      return 'button';
    } else {
      return 'region';
    }
  }
  @action close(event: MouseEvent) {
    if (this.innerElement?.contains(event.target)) {
      return;
    }
    if (this.args.close) {
      this.args.close();
    }
  }
  innerElement?: HTMLDivElement = undefined;
  @action
  registerModal(element: HTMLDivElement) {
    this.innerElement = element;
  }
}
